
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import IQueryTypeDefinitionDto = MdbsCore.IQueryTypeDefinitionDto;

@Component({
  name: 'QueryCreateMenuItem',
  components: {},
})
export default class QueryCreateMenuItem extends Vue {

  @Prop({required: true})
  private queryTypeDefinition: IQueryTypeDefinitionDto;

  @Emit("onCreateQuery")
  onCreateQuery() {
    return this.queryTypeDefinition;
  }

}
